import { StarOffIcon } from './StarOffIcon';

/**
 * author: Austin Andrews
 * id 3CE96C58-D12F-474D-916F-D0509E3BA408
 * name star-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-off.svg
 * tags
 */
export const FavoriteOffIcon = StarOffIcon;
export default FavoriteOffIcon